var map = {
	"./000-cover.png": "7947",
	"./001-low_hanging_fruit.png": "00bd",
	"./002-piece_of_cake.png": "f9f7",
	"./003-it_aint_rocket_science.png": "027b",
	"./005-ornitorinco.png": "d42a",
	"./008-and_arm_and_a_leg.png": "faed",
	"./013-just_squeaking_by.png": "5bc1",
	"./020-dont_put_all_your_eggs_in_one_basket.png": "beb3",
	"./040-meterse_en_un_berenjenal.png": "b579",
	"./100-monster_task.png": "b744",
	"./coffee_break.png": "79be",
	"./infinity-when_pigs_fly.png": "c05b",
	"./marron.png": "90b8",
	"./unknown-here_be_dragons.png": "3683",
	"./yak_shaving.png": "88bb"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6863";